import IMSLogviewer from './IMSLogviewer/IMSLogviewer';
import IMSLogDetails from './IMSLogviewer/IMSLogDetails';
import { Switch, Route } from 'react-router-dom';

const LogViewerPage = () => {
	return (
		<>
			<Switch>
				<Route
					exact
					path={'/IMSAdministration/Logviewer'}
					component={IMSLogviewer}
				/>
				<Route
					path={'/IMSAdministration/Logviewer/:id'}
					render={() => <IMSLogDetails />}
				/>
			</Switch>
		</>
	);
};

export default LogViewerPage;
